import React from "react";

const Displayer = (props) => {
  return (<div className="displayer">{props.children}</div>);
};

export default Displayer;
